import { invalidateClientFlatFeeBillingQueries } from '../FlatFeeBillingDashboard/hooks/queries/useFlatFeeBillingDashboardQuery';
import { invalidateClientRetainerBillingQueries } from '../RetainerBillingDashboard/hooks/queries/useRetainerBillingDashboardQuery';
import { invalidateClientSubscriptionBillingQueries } from '../SubscriptionBillingDashboard/hooks/queries/useSubscriptionBillingDashboardQuery';

/**
 * Invalidates flat-fee, retainer, and subscription client billing dashboard React Query caches.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @returns {Promise<unknown[]>}
 */
export const invalidateClientBillingDashboardQueries = (queryClient) =>
  Promise.all([
    invalidateClientFlatFeeBillingQueries(queryClient),
    invalidateClientRetainerBillingQueries(queryClient),
    invalidateClientSubscriptionBillingQueries(queryClient),
  ]);
